import Choices from "choices.js";

$(function() {
    const $fields = $('.js-field');

    $fields.each(function(i, el) {
        const $field = $fields.eq(i);
        if ($field.hasClass("js-choices")) {
            new Choices($field.find("select").get(0), {
                itemSelectText: "",
                searchEnabled: false,
                classNames: {
                    containerOuter: 'choices field__input',
                    listDropdown: 'choices__list--dropdown field__input',
                },
            });
        }
    })
});



// WEBPACK FOOTER //
// ./static/components/Choices.js